export default __webpack_public_path__ + "src/assets/vlyby_logo.svg";